import type { FC } from "react";
import { useLocation } from "react-router-dom";

import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";

/**
 * This component is necessary to provide a location to `<ErrorBoundary>` in situations where hooks aren't usable (in routes for instance)
 */
export const ErrorBoundaryWrapper: FC = () => {
  const location = useLocation();

  return <ErrorBoundary pathname={location.pathname} />;
};
